// @ vendors
const moment = require('moment');
// @ constants
const actionTypes = require('constants/actionTypes');
const { DATE_FORMAT_API } = require('constants/index');
// @ helpers
const { APIPost } = require('utilities/APIRequestHelper');
const { download } = require('utilities/fileDownloadHelper');
const { formatText } = require('core/i18n').i18n;
import { openPDFViewer, showPDFFailure } from 'utilities/contactCenter/pdfViewer';
// @ constants
import { VIEWER } from 'constants/contactCenter/pdfViewer';
const FILE_TYPE_PDF = 'P';
const FILE_TYPE_EXCEL = 'E';
const FILE_EXTENSION_EXCEL = 'xls';
const FILE_EXTENSION_PDF = 'pdf';
const MIME_TYPE_EXCEL = 'application/vnd.ms-excel';
const MIME_TYPE_PDF = 'application/pdf';

// For downloadCardsTransactions if no dates are
// selected for the filter, we get movements from last 6 months
const DEFAULT_CARD_TRANSACTION_FROM = 6;
const DEFAULT_CARD_TRANSACTION_FROM_UNIT = 'months';

const requestCardTransactionsDownloadInProgress = () => ({
    type: actionTypes.FETCH_CARDS_TRANSACTIONS_DOWNLOAD_REQUEST
});

const requestCardTransactionsDownloadSuccess = () => ({
    type: actionTypes.FETCH_CARDS_TRANSACTIONS_DOWNLOAD_SUCCESS
});

const requestCardTransactionsDownloadFailure = (payload) => ({
    type: actionTypes.FETCH_CARDS_TRANSACTIONS_DOWNLOAD_FAILURE,
    payload
});

const requestCardTransactionsDownloadScaRequired = (cardId, format) =>({
    type: actionTypes.FETCH_CARDS_TRANSACTIONS_DOWNLOAD_SCA_REQUIRED,
    cardId,
    format
})

const resetCardTransactionsDownloadSca = () => ({
    type: actionTypes.FETCH_CARD_TRANSACTIONS_DOWNLOAD_SCA_RESET
});

const resetScaForCardTransactionsDownload = () => (dispatch) => {
    dispatch(resetCardTransactionsDownloadSca());
}

const downloadCardsTransactions = (cardId, type, loadType = undefined) => (dispatch, getState) => {
    const immCard = getState().cards.getIn(['byId', cardId]);
    const immFilters = getState().cardsTransactions.get('filters');
    const immDateFilter = immFilters.get('date');
    const immSituationFilter = immFilters.get('situation');
    const immStateFilter = immFilters.get('state');
    const immAmountFilter = immFilters.get('amount');

    const defaultFromField = moment()
        .startOf('day')
        .subtract(DEFAULT_CARD_TRANSACTION_FROM, DEFAULT_CARD_TRANSACTION_FROM_UNIT);

    const optionalFields = {
        fromDate: immDateFilter.get('from') || defaultFromField,
        toDate: immDateFilter.get('to') || moment().startOf('day')
    };

    const requestData = {
        header: {
            responseType: !__CONTACT_CENTER__ ? 'arraybuffer' : 'blob'
        },
        query: {
            numeroContrato: immCard.get('contract').get('number'),
            producto: immCard.get('contract').get('product'),
            pan: immCard.get('number'),
            fechaDesde: optionalFields.fromDate.format(DATE_FORMAT_API),
            fechaHasta: optionalFields.toDate.format(DATE_FORMAT_API),
            indTxtExcel: type === 'XLS' ? FILE_TYPE_EXCEL : FILE_TYPE_PDF
        }
    };
    if(immAmountFilter.get('isActive')) {
        requestData.query.minImporte = immAmountFilter.get('from').get('amount');
        requestData.query.maxImporte = immAmountFilter.get('to').get('amount');
    }

    if(immStateFilter.get('isActive')) {
        requestData.query.filtroIndPagoFacil = immStateFilter.get('selected');
    }

    if(immSituationFilter.get('isActive')) {
        requestData.query.filtroSituacionOperacion = immSituationFilter.get('selected');
    }

    dispatch(requestCardTransactionsDownloadInProgress(cardId));
    return APIPost({
        dispatch,
        endpoint: 'cardDownloadTransactions',
        params: requestData
    })
    .then(
        response => {
            const extension = type === 'XLS' ? FILE_EXTENSION_EXCEL : FILE_EXTENSION_PDF;
            const fileName = `${formatText(
                'applicationDownloadFileNames-cardsTransactions'
            )}.${extension}`;
            const fileType = type === 'XLS' ? MIME_TYPE_EXCEL : MIME_TYPE_PDF;

            dispatch(requestCardTransactionsDownloadSuccess(response, cardId));
            if (!loadType) {
                download(response.xhr.response, fileName, fileType);
            } else if (loadType === VIEWER) {
                openPDFViewer(response.xhr.response);
            }
        },
        error => {
            if (loadType === VIEWER) {
                showPDFFailure();
            }
            if (error.error && error.error.status && error.error.status === 403) {
                dispatch(requestCardTransactionsDownloadScaRequired(cardId, type));
            }
            dispatch(requestCardTransactionsDownloadFailure(error, cardId));
        }
    );
};

module.exports = {
    downloadCardsTransactions,
    resetScaForCardTransactionsDownload
};
